<template>
  <div
    :class="{ 'group-container': true, 'active-group': showChilds }"
    :style="`${isOpen ? 'text-align: right;' : 'text-align: center;'}`"
  >
    <div
      :class="{ titles: true, 'minimal-title': !isOpen }"
      :title="!isOpen ? name : null"
      tabindex="0"
      @keydown.enter="toggleChild"
    >
      <i :class="icon"></i>
      <a v-show="isOpen" class="group-name" @click="toggleChild">
        {{ name }}
      </a>
      <div v-show="isOpen" class="icon-container">
        <span v-show="showChilds">
          <i class="fas fa-chevron-down"></i>
        </span>
        <span v-show="!showChilds">
          <i class="fas fa-chevron-left"></i>
        </span>
      </div>
    </div>
    <transition name="slide-fade">
      <ul v-show="showChilds && isOpen" :id="groupID">
        <template v-for="(child, index) in childs">
          <li v-if="$acl.can('view', child.route_name)" :key="index">
            <router-link :to="child.route">{{ child.name }}</router-link>
          </li>
        </template>
      </ul>
    </transition>
  </div>
</template>
<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
    },
    name: {},
    icon: {},
    childs: {
      type: Array,
    },
  },
  created() {
    this.$nextTick(() => {
      setTimeout(() => {
        var count = $(`#${this.groupID} li a.router-link-exact-active.router-link-active`)
          .length;
        if (count > 0) this.showChilds = true;
      }, 2000);
    });
  },
  mounted() {
    this.$root.$on("side-bar:open-other", (e) => {
      if (this.groupID != e) this.showChilds = false;
    });
  },
  data() {
    return {
      showChilds: false,
      groupID: Math.random().toString(36).substring(7),
    };
  },
  methods: {
    toggleChild() {
      this.showChilds = !this.showChilds;
      this.$root.$emit("side-bar:open-other", this.groupID);
    },
  },
};
</script>
<style scoped>
.slide-fade-enter-active {
  transition: all 0.25s ease;
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.group-container {
  display: block;
  width: 100%;
  position: relative;
  text-align: center;
  margin-bottom: 2px;
}

.group-container svg,
.group-container > .titles > i {
  color: #7c8398;
  font-size: 0.92rem;
  width: 18px;
  text-align: center;
}

.group-name {
  color: #cbd5e1;
  font-weight: 600;
  font-size: 0.83rem;
  padding-right: 12px;
  display: inline-block;
}

ul {
  list-style: none;
  background: transparent;
  margin: 0;
  padding-bottom: 4px;
}

a {
  color: #8b93a7;
  transition: color 150ms ease, background-color 150ms ease;
}

.active-group {
  border-radius: 10px;
}

.minimal-title {
  line-height: 1;
  padding: 12px 0 !important;
}

.titles {
  display: flex;
  align-items: center;
  padding: 9px 10px;
  border-radius: 9px;
  cursor: pointer;
  transition: background-color 150ms ease;
}

.minimal-title {
  justify-content: center;
}

.titles:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.titles:focus-visible {
  outline: 2px solid #818cf8;
  outline-offset: 1px;
}

.active-group > .titles:hover {
  background-color: transparent;
}

.icon-container {
  display: inline-block;
  float: left;
  padding: 0 4px;
  color: #7c8398;
  font-size: 0.7rem;
}

.side-bar-items .group-container ul li {
  position: relative;
  border-radius: 8px;
  margin: 1px 0;
  overflow: hidden;
}

.side-bar-items .group-container ul li a {
  display: block;
  width: 100%;
  padding: 7px 16px 7px 6px;
  font-size: 0.82rem;
  border-radius: 8px;
}

.side-bar-items .group-container ul li a:hover {
  color: #e2e8f0;
  background-color: rgba(255, 255, 255, 0.05);
}

.side-bar-items .group-container ul li a:focus-visible {
  outline: 2px solid #818cf8;
  outline-offset: -2px;
}

/* active leaf item: soft tint + short rounded indicator, not a full block */
.side-bar-items .group-container ul li:has(> a.router-link-exact-active) {
  background-color: rgba(129, 140, 248, 0.14);
}

.side-bar-items .group-container ul li:has(> a.router-link-exact-active)::before {
  content: "";
  position: absolute;
  top: 50%;
  right: 0;
  width: 3px;
  height: 60%;
  transform: translateY(-50%);
  background: #818cf8;
  border-radius: 3px 0 0 3px;
}

.side-bar-items .group-container ul li a.router-link-exact-active {
  color: #eef2ff;
  font-weight: 600;
}
</style>
